const promotionsConstants = {
  GET_PROMOTIONS_LIST_REQUEST:           'GET_PROMOTIONS_LIST_REQUEST',
  GET_PROMOTIONS_LIST_SUCCESS:           'GET_PROMOTIONS_LIST_SUCCESS',
  GET_PROMOTIONS_LIST_FAILURE:           'GET_PROMOTIONS_LIST_FAILURE',
  GET_MAIN_PROMOTIONS_SUCCESS:           'GET_MAIN_PROMOTIONS_SUCCESS',
  GET_PROMOTIONS_DETAIL_REQUEST:         'GET_PROMOTIONS_DETAIL_REQUEST',
  GET_PROMOTIONS_DETAIL_SUCCESS:         'GET_PROMOTIONS_DETAIL_SUCCESS',
  GET_PROMOTIONS_DETAIL_FAILURE:         'GET_PROMOTIONS_DETAIL_FAILURE',
  PROMOTIONS_SHOW_MORE_REQUEST:          'PROMOTIONS_SHOW_MORE_REQUEST',
  PROMOTIONS_SHOW_MORE_SUCCESS:          'PROMOTIONS_SHOW_MORE_SUCCESS',
  PROMOTIONS_SHOW_MORE_FAILURE:          'PROMOTIONS_SHOW_MORE_FAILURE',
  PROMOTIONS_DETAIL_RESET_INITIAL_STATE: 'PROMOTIONS_DETAIL_RESET_INITIAL_STATE',
};

export default promotionsConstants;